import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';
import { imgUrl } from '../utils/imgUrl';
import ProtectedImage from './ProtectedImage';
import './ProfileCard.css';

const ProfileCard = ({ profile }) => {
  const navigate = useNavigate();
  const [shortlisted, setShortlisted] = useState(false);
  const [interestSent, setInterestSent] = useState(false);
  const [sending, setSending] = useState(false);

  const age = profile.date_of_birth
    ? Math.floor((new Date() - new Date(profile.date_of_birth)) / (365.25 * 24 * 60 * 60 * 1000))
    : null;

  const initials = `${profile.first_name?.[0] || ''}${profile.last_name?.[0] || ''}`;

  const handleShortlist = async (e) => {
    e.stopPropagation();
    try {
      const res = await authService.toggleShortlist(profile.id);
      setShortlisted(res.data.shortlisted);
    } catch (err) { console.error(err); }
  };

  const handleSendInterest = async (e) => {
    e.stopPropagation();
    if (interestSent || sending) return;
    setSending(true);
    try {
      await authService.sendInterest(profile.id);
      setInterestSent(true);
    } catch (err) {
      console.error(err);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="profile-card" onClick={() => navigate(`/profile/${profile.id}`)}>
      <div className="profile-card-avatar">
        {profile.profile_photo
          ? <ProtectedImage src={imgUrl(profile.profile_photo)} alt={profile.first_name} style={{ width: '100%', height: '100%' }} />
          : <span>{initials}</span>
        }
      </div>
      <div className="profile-card-body">
        <h3>{profile.first_name} {profile.last_name}</h3>
        <p className="profile-id">{profile.profile_id}</p>
        <div className="profile-tags">
          {age && <span>{age} yrs</span>}
          {profile.height && <span>{profile.height} cm</span>}
          {profile.location?.city && <span>📍 {profile.location.city}</span>}
          {profile.religious_details?.religion && <span>{profile.religious_details.religion}</span>}
          {profile.religious_details?.caste && <span>{profile.religious_details.caste}</span>}
          {profile.professional_details?.occupation && <span>💼 {profile.professional_details.occupation}</span>}
        </div>
        {profile.about_me && <p className="profile-about">{profile.about_me}</p>}
      </div>
      <div className="profile-card-actions">
        <button
          className={`btn-interest ${interestSent ? 'sent' : ''}`}
          onClick={handleSendInterest}
          disabled={sending || interestSent}
        >
          {sending ? 'Sending...' : interestSent ? '✓ Interest Sent' : 'Send Interest'}
        </button>
        <button className={`btn-shortlist ${shortlisted ? 'active' : ''}`} onClick={handleShortlist}>
          {shortlisted ? '♥ Shortlisted' : '♡ Shortlist'}
        </button>
      </div>
    </div>
  );
};

export default ProfileCard;
